import getApiClient from '@/plugins/api'

export default {
    loadAgencies() {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        self.searchParams.page = self.page
        self.searchParams.itemsPerPage = self.perPage

        api.get('agencies', {
            params: self.searchParams
        })
            .then((result) => {
                self.agencies = result.data['hydra:member']
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    changePage: function(page) {
        this.page = page
    }
}
